var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"answer-wrapper cursor-pointer",class:_vm.selected ? 'selected' : '',domProps:{"innerHTML":_vm._s(_vm.iconPath)}})}
var staticRenderFns = []

export { render, staticRenderFns }